import { createClient } from '@sanity/client';

import { SANITY_API_VERSION, SANITY_DATASET, SANITY_PROJECT_ID } from './config';

// Read-only (Viewer) robot token. Every Sanity read in web runs server-side
// (getStaticProps, getServerSideProps, API routes), so the token never reaches
// the browser. It is what lets the dataset be made private (FFH-2593); while
// the dataset is still public it is harmless. Authenticated reads still go
// through the API CDN, so `useCdn: true` keeps its caching economics.
const SANITY_READ_TOKEN = process.env.SANITY_READ_TOKEN;

export const sanityClient = createClient({
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: SANITY_API_VERSION,
  useCdn: true,
  token: SANITY_READ_TOKEN
});

// Origin (non-CDN) client for pages that must see a publish immediately after
// it happens. The API CDN can lag a publish by up to a minute, which is long
// enough for an on-demand ISR regeneration to bake in the stale document.
// Every read still carries the token so the private dataset stays readable.
export const sanityOriginClient = createClient({
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: SANITY_API_VERSION,
  useCdn: false,
  token: SANITY_READ_TOKEN
});
